import React from "react";
import "./DSASection.css";

const DSASection = ({ onOpenDSAForm }) => {
  return (
    <section id="dsa" className="dsa-main-section">
      <div className="dsa-container">
        <div className="dsa-header">
          <h2>Become DSA Partner</h2>
          <p className="dsa-desc-large">
            Join India's Fastest Growing Loan Distribution Network And Start
            Earning Attractive Commissions
          </p>
          <p className="dsa-desc-small">
            Loan Agents, Ex-Bankers, Financial Analysts, Insurance Agents,
            Mutual Fund Agents, Builders Or Professionals From Any Field.
          </p>
        </div>

        <div className="dsa-cards-row">
          <div className="dsa-card">
            <h4>Attractive Commissions</h4>
            <p>Earn Competitive Commissions On Every Loan Disbursal.</p>
          </div>
          <div className="dsa-card">
            <h4>Comprehensive Training</h4>
            <p>Get Detailed Training On Products And Sales Techniques.</p>
          </div>
          <div className="dsa-card">
            <h4>Dedicated Support</h4>
            <p>24/7 Support Team To Assist You Throughout The Process.</p>
          </div>
        </div>

        <button className="dsa-btn-full" onClick={onOpenDSAForm}>
          Become DSA
        </button>
      </div>
    </section>
  );
};

export default DSASection;
